import { KioskHeartbeatRequest, Urls } from '@2meters/types'
import { functions } from 'api/Firebase/firebase-init'
import { httpsCallable } from 'firebase/functions'

export function kioskHeartbeat(request: KioskHeartbeatRequest) {
  const func = httpsCallable(functions, `${Urls.visitor.prefix}${Urls.visitor.kioskHeartbeat}`)
  return func(request)
}
